const root = '/checkout';

const registerRoutes = [
  {
    path: `${root}/register`,
    name: 'checkoutSelectClub',
    component: () => import('./selectClub.vue'),
    meta: {
      title: 'Select a Club',
      requiresAuth: false,
      noLayoutMobile: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/register/:clubId`,
    name: 'checkoutRegister',
    component: () => import('./register.vue'),
    meta: {
      title: 'Create an Account',
      windowViewTitle: 'Create an Account',
      isWindowView: true,
      requiresAuth: false,
      hideFooter: true,
    },
  },
];

export default registerRoutes;
